var _style, _rect, _path, _path2, _rect2, _path3, _rect3, _defs, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleMallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B3B3B3;}\n\t.st2{fill:#E9D2A2;}\n\t.st3{fill:#333333;}\n\t.st4{fill:#1A1A1A;}\n\t.st5{clip-path:url(#SVGID_00000155120432379397930650000012936564517558707852_);}\n\t.st6{fill:#FA4131;}\n\t.st7{fill:#E6E6E6;}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.72,84.35l-0.44-0.75c-0.8-1.37-0.34-3.12,1.03-3.92l0.62-0.36c15.11-8.84,25.67-23.33,31.1-39.97 c1-3.07,3.03-5.72,5.73-7.49c3.3-2.15,7.38-2.84,11.2-1.9c3.82,0.95,8.88,6.38,10.78,9.83l-7.43,0.49l-0.03-0.06 c-0.92-1.65-2.36-2.99-4.14-3.63c-2.39-0.85-4.91-0.51-6.96,0.91c-1.48,1.03-2.48,2.61-3.01,4.33 c-5.67,18.37-17.92,33.82-34.52,43.53C198.28,86.18,196.52,85.72,195.72,84.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208,452.67l16.86,5.84c1.98,0.68,4.05,1.03,6.14,1.03h57.24c3.41,0,6.18-2.77,6.18-6.18v-7.01 c0-3.41-2.77-6.18-6.18-6.18h-79.08c-1.97,0-3.57,1.6-3.57,3.57v5.56C205.6,450.82,206.56,452.18,208,452.67z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247.13,
    y: 109.33,
    className: "st2",
    width: 8.85,
    height: 330.84
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.05,41.48h-13v64.01c0,2.12,1.72,3.84,3.84,3.84h5.32c2.12,0,3.84-1.72,3.84-3.84V41.48z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 242.46,
    y: 39.37,
    className: "st4",
    width: 18.71,
    height: 4.22
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M208,452.67l16.86,5.84c1.98,0.68,4.05,1.03,6.14,1.03h57.24c3.41,0,6.18-2.77,6.18-6.18v-7.01 c0-3.41-2.77-6.18-6.18-6.18h-79.08c-1.97,0-3.57,1.6-3.57,3.57v5.56C205.6,450.82,206.56,452.18,208,452.67z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173124215134854695220000001488891903012061348_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173124215134854695220000001488891903012061348_)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 281.34,
    y: 432.08,
    className: "st6",
    width: 13.08,
    height: 36.31
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205.06,
    y: 432.08,
    className: "st6",
    width: 13.08,
    height: 36.31
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 246.15,
    y: 327.56,
    className: "st7",
    width: 10.8,
    height: 112.61
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleMallet);
export default __webpack_public_path__ + "static/media/singleMallet.84d6bf4a86f5a7259120e26e1012657d.svg";
export { ForwardRef as ReactComponent };